import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import {
  AnimatedRemoteComponent,
  BadgeComponent,
  ElevioTriggerDirective,
  IconComponent,
  PageComponent,
} from '@ftr/foundation'
import { HelpContactDetailsComponent } from './help-contact-details/help-contact-details.component'
import { HelpOrderingInformationComponent } from './help-ordering-information/help-ordering-information.component'
import { HelpPlatformSupportComponent } from './help-platform-support/help-platform-support.component'
import { HelpSubMenuFlyoutCardComponent } from './help-sub-menu-flyout/card/help-sub-menu-flyout-card.component'
import { HelpSubMenuFlyoutItemComponent } from './help-sub-menu-flyout/item/help-sub-menu-flyout-item.component'
import { HelpComponent } from './help.component'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AnimatedRemoteComponent,
    PageComponent,
    IconComponent,
    BadgeComponent,
    ElevioTriggerDirective,
  ],
  declarations: [
    HelpComponent,
    HelpContactDetailsComponent,
    HelpPlatformSupportComponent,
    HelpOrderingInformationComponent,
    HelpSubMenuFlyoutItemComponent,
    HelpSubMenuFlyoutCardComponent,
  ],
  exports: [
    HelpComponent,
    HelpContactDetailsComponent,
    HelpPlatformSupportComponent,
    HelpOrderingInformationComponent,
    HelpSubMenuFlyoutCardComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HelpModule {}
